import * as React from "react";

export interface FeaturesCarouselProps {
    onlineMembers: number;
    onlineMembersLast7Days: number;
}

export const FeaturesCarousel = ({ onlineMembers, onlineMembersLast7Days }: FeaturesCarouselProps) => {
    return <div className="app-paz-couples">
        <a href="//pazintys.draugas.lt">
            <svg className="hearts" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24">
                <path d="M0.2,5.4c0-0.1,0-0.3,0-0.4c0.1-0.7,0.3-1.4,0.6-2c0.6-1.1,1.4-1.8,2.5-2.4C3.9,0.3,4.5,0.1,5.2,0c1.6-0.2,3,0.3,4.2,1.3
							C9.6,1.5,9.8,1.8,10.1,2c0,0,0,0,0,0c0.9-1.1,2.1-1.8,3.5-2c1.3-0.2,2.5,0.1,3.6,0.7c2.2,1.3,3,3.6,2.8,5.4c0,0-0.1,0-0.1,0
							c-0.5,0-1.1,0-1.6,0.2c-0.1,0-0.2,0-0.3,0.1c0,0-0.1,0-0.1,0c-0.4-0.5-0.8-1-1.4-1.3c-0.6-0.4-1.2-0.6-1.9-0.7
							c-1-0.2-1.9-0.1-2.8,0.3c-0.8,0.3-1.4,0.8-2,1.5C9.4,6.8,9,7.6,8.8,8.5C8.7,9.3,8.7,10,8.7,10.7c0.1,0.8,0.3,1.6,0.7,2.4
							c0.4,1,1,1.8,1.6,2.7c0.2,0.2,0.3,0.5,0.5,0.7c0,0,0,0,0,0c-0.5,0.4-1,0.7-1.4,1.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.4-1-0.7-1.5-1.1
							c-0.9-0.6-1.7-1.2-2.6-1.8c-0.9-0.6-1.7-1.4-2.5-2.1c-0.7-0.7-1.3-1.4-1.7-2.2C0.9,9.2,0.5,8.3,0.3,7.2C0.2,6.9,0.2,6.5,0.2,6.1
							c0,0,0-0.1,0-0.1C0.2,5.8,0.2,5.6,0.2,5.4z"></path>
                <path d="M17.6,7.7c0.4-0.2,0.8-0.4,1.2-0.4c1.3-0.3,2.5,0,3.5,0.9c0.8,0.7,1.3,1.5,1.4,2.5c0.1,0.7,0,1.4-0.2,2.1
							c-0.4,1-1,1.9-1.9,2.6c-0.7,0.6-1.5,1-2.3,1.4c-0.9,0.4-1.9,0.7-2.9,1c-0.6,0.2-1.2,0.4-1.9,0.6c-0.2,0.1-0.3,0.1-0.5,0.2
							c0,0-0.1,0-0.1,0c-0.4-0.7-0.9-1.3-1.4-1.9c-0.5-0.6-1-1.3-1.4-1.9c-0.5-0.8-1-1.6-1.3-2.6c-0.3-0.8-0.4-1.6-0.3-2.5
							C9.7,8.6,9.9,7.8,10.5,7c0.7-0.9,1.6-1.5,2.7-1.7C15,5,16.8,5.9,17.6,7.7C17.6,7.6,17.6,7.6,17.6,7.7z"></path>
            </svg>
        </a>
        <div id="myCarousel" className="carousel slide app-t-slider" data-ride="carousel">

            <ol className="carousel-indicators points">
                <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
                <li data-target="#myCarousel" data-slide-to="1" className=""></li>
                <li data-target="#myCarousel" data-slide-to="2" className=""></li>
                <li data-target="#myCarousel" data-slide-to="3" className=""></li>
                <li data-target="#myCarousel" data-slide-to="4" className=""></li>
            </ol>

            <div className="carousel-inner" onClick={() => window.location.href = '//pazintys.draugas.lt'}>
                <div className="item active">
                    <div className="t">Dabar prisijungę nariai:</div>
                    <div className="count">{onlineMembers}</div>
                </div>
                <div className="item">
                    <div className="t">Per 7 dienas prisijungė:</div>
                    <div className="count">{onlineMembersLast7Days}</div>
                </div>
                <div className="item">
                    <div className="count">150 000 +</div>
                    <div className="t">ieškančių</div>
                </div>
                <div className="item">
                    <div className="count">500 000 000 +</div>
                    <div className="t">išsiųstų žinučių.</div>
                </div>
                <div className="item">
                    <div className="count">100 000 +</div>
                    <div className="t">jau rado antrąją pusę!</div>
                </div>
            </div>
        </div>
    </div >;
}